module.exports = __webpack_public_path__ + "img/248.25edd20d.jpg";